export default __webpack_public_path__ + "static/healthysexual-logo-936fbd6f61d18944284db4f1ca6efb31.png";